import { createAsyncThunk } from '@reduxjs/toolkit'

import * as api from 'connections/restApi'

export const get = createAsyncThunk(
  'optimizationsPressMachines/get',
  async payload => {
    const response = await api.getOptimizationsPressMachines(payload)
    return response
  }
)
